$(document).ready(function () {
  $('.slick-store-slider').flickity({
    cellAlign: 'center',
    contain: false,
    wrapAround: false,
    groupCells: 1, 

    prevNextButtons: false,
    pageDots: true,

    autoPlay: 3000,
    pauseAutoPlayOnHover: true,
    wrapAround: true,
    draggable: true
  });
});
